import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import { getScrollBarStyles } from '../../../config/styles';

export const TopPathsChartList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const TopPathsChartListOverflow = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  overflow-y: auto;
  height: 100%;
  ${getScrollBarStyles(4)};
`;

export const TopPathChartRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
`;

export const TopPathChartHeader = styled.div`
  display: flex;
  flex-direction: row;
  row-gap: 4px;
  line-height: 1;
  align-items: center;
`;

export const Heading = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary900};
  strong {
    font-weight: 600;
  }
`;

export const VerticalDivider = styled.div`
  width: 4px;
  background-color: ${theme.colors.border};
  justify-self: center;
`;
